module.exports = __webpack_public_path__ + "static/media/menu_exames.5ad9f5c9.png";